import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function AssetManagementLicenseMwali() {

    return (
        <main className='main'>
            <IntroSection
                title="Asset Management License – Mwali (Comoros)"
                subtitle="Manage Global Investments with a MISA License"
                description="Mwali (Mohéli, Comoros), regulated by the Mwali International Services Authority (MISA), provides internationally recognized Asset Management Licenses. With a balance of credibility, flexibility, and cost-effectiveness, Mwali is the ideal offshore hub for fund managers, portfolio managers, and family offices."
                badges={[
                    "Fund Management",
                    "Wealth & Portfolio Management",
                    "Family Office Services"
                ]}
                buttonText="Request a Mwali Asset Management Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/asset-management-license-mwali-hero.png")}
                imageAlt="Mwali Asset Management"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Mwali for Asset Management?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Global Recognition",
                                                text: "More credibility than newer jurisdictions like Western Sahara."
                                            },
                                            {
                                                title: "MISA-Regulated",
                                                text: "Compliance aligned with FATF standards."
                                            },
                                            {
                                                title: "Diverse Services",
                                                text: "Fund management, wealth management, advisory, and family offices."
                                            },
                                            {
                                                title: "Banking & Custody Access",
                                                text: "Easier onboarding with PSPs, custodians, and fund administrators."
                                            },
                                            {
                                                title: "Cost-Effective",
                                                text: "Lower costs than EU fund hubs such as Luxembourg and Malta."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="What the License Covers"
                        blocks={[
                            {
                                title: "Mwali Asset Management License",
                                items: [
                                    { text: "Manage investment funds & collective schemes." },
                                    { text: "Offer portfolio management services for clients worldwide." },
                                    { text: "Operate wealth management & family office structures." },
                                    { text: "Provide investment advisory and financial consultancy." },
                                    { text: "Launch private equity & venture capital funds." },
                                    { text: "Combine with brokerage, forex, or crypto modules if desired." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital Requirements"
                        item={
                            [
                                {
                                    title: "Moderate Capital",
                                    text: "Compared to EU regulators."
                                },
                                {
                                    title: "Typical Range",
                                    text: "USD 50,000–100,000+, depending on scope and structure."
                                },
                                {
                                    title: "Final Requirement",
                                    text: "Set by MISA during review."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Mwali Asset Management License'
                        services={
                            [
                                {
                                    title: "Credibility & Trust",
                                    text: "Accepted by international partners."
                                },
                                {
                                    title: "Compliance-Based",
                                    text: "AML/KYC aligned with FATF recommendations."
                                },
                                {
                                    title: "Multi-Structure Flexibility",
                                    text: "Supports family offices, funds, and advisory firms."
                                },
                                {
                                    title: "Faster Setup",
                                    text: "2–3 weeks vs 6–12 months in EU jurisdictions."
                                },
                                {
                                    title: "Scalable",
                                    text: "Expand services under one license."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Select fund or management model."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish an IBC in Mwali (Comoros)."
                                },
                                {
                                    title: "Compliance Documentation",
                                    text: "Prepare AML/KYC manuals, business plan, and risk framework."
                                },
                                {
                                    title: "Application Filing",
                                    text: "Offshore Advisory submits documents to MISA."
                                },
                                {
                                    title: "Approval & Issuance",
                                    text: "License granted within 2–3 weeks."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "2–3 weeks",
                            },
                            {
                                name: "Setup Costs",
                                description: "From USD 25,000+",
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 50k–100k+ (flexible, scope-dependent)",
                            },
                            {
                                name: "Annual Costs",
                                description: "Renewals: annual fees payable to MISA",
                            },
                        ]}
                    />


                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Recognized MISA agent with asset management expertise."
                                },
                                {
                                    text: "Full-service setup: incorporation, compliance, licensing, banking."
                                },
                                {
                                    text: "Connections with fund administrators & custodians."
                                },
                                {
                                    text: "Tailored solutions for HNWI family offices and PE/VC funds."
                                },
                                {
                                    text: "Transparent pricing & efficient processing."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Ready to manage assets globally?"
                        description="With moderate requirements, fast approvals, and global recognition, Mwali is a trusted offshore hub for asset management."
                        buttonText="Book a Mwali Asset Management Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is a Mwali asset management license recognized globally?",
        content: [
            { type: "answer", text: "Yes — it carries credibility in the offshore industry, trusted more than emerging regulators." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "8–12 weeks, faster than EU options like Malta or Luxembourg." },
        ],
    },
    {
        question: "Is there a strict capital requirement?",
        content: [
            { type: "answer", text: "No — capital is moderate, usually USD 50k–100k, depending on the business model." },
        ],
    },
    {
        question: "Can I combine it with other licenses?",
        content: [
            { type: "answer", text: "Yes — you can combine asset management with brokerage, trust, or crypto modules." },
        ],
    },
    {
        question: "Do you assist with banking/custody?",
        content: [
            { type: "answer", text: "Yes — Offshore Advisory provides introductions to custodians, PSPs, and EMI providers." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We launched a wealth management company in Mwali with Offshore Advisory’s guidance. The license was approved in 10 weeks.",
        author: "Daniel P.",
        role: "Wealth Manager"
    },
    {
        quote: "Our private equity structure was licensed under MISA. Offshore Advisory handled incorporation, licensing, and compliance seamlessly.",
        author: "Sofia L.",
        role: "Fund Manager"
    }
];
